var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaysOfWorking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-miterlimit:10;}.a,.b{stroke:#fff;stroke-width:2px;}.b{fill:url(#a);}.c{fill:#fff;}.d{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9987ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453878"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1096.435 -51.615)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(1096.435 51.615)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1096.435 51.615)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -10, -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(10 7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.03 17.427)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1249.413,94.584h-36.2a5.376,5.376,0,0,1-5.369-5.369v-27.1a5.376,5.376,0,0,1,5.369-5.369h36.2a5.376,5.376,0,0,1,5.37,5.369v27.1A5.376,5.376,0,0,1,1249.413,94.584Zm-36.2-32.863a.393.393,0,0,0-.392.392v27.1a.393.393,0,0,0,.392.392h36.2a.392.392,0,0,0,.391-.392v-27.1a.392.392,0,0,0-.391-.392Z",
    transform: "translate(-1207.843 -56.743)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.162 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1234.775,63.225a1.383,1.383,0,0,1-1.383-1.383V56.036a1.383,1.383,0,0,1,2.765,0v5.807A1.383,1.383,0,0,1,1234.775,63.225Z",
    transform: "translate(-1233.392 -54.653)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.223 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1247.527,63.225a1.383,1.383,0,0,1-1.383-1.383V56.036a1.383,1.383,0,1,1,2.765,0v5.807A1.382,1.382,0,0,1,1247.527,63.225Z",
    transform: "translate(-1246.144 -54.653)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.824 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1221.7,63.225a1.383,1.383,0,0,1-1.383-1.383V56.036a1.383,1.383,0,1,1,2.765,0v5.807A1.382,1.382,0,0,1,1221.7,63.225Z",
    transform: "translate(-1220.321 -54.653)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1233.215,85.179V74.425q-3,2.3-4.042,2.3a1.2,1.2,0,0,1-.88-.4,1.275,1.275,0,0,1-.383-.916,1.034,1.034,0,0,1,.378-.887,8.331,8.331,0,0,1,1.335-.732,10,10,0,0,0,2.286-1.418,9.693,9.693,0,0,0,1.519-1.667q.661-.921.863-1.135a1.033,1.033,0,0,1,.756-.212,1.21,1.21,0,0,1,1,.484,2.117,2.117,0,0,1,.378,1.335V84.718q0,2.375-1.619,2.375a1.488,1.488,0,0,1-1.159-.484A2.077,2.077,0,0,1,1233.215,85.179Z",
    transform: "translate(-1210.503 -56.604)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaysOfWorking);
export default __webpack_public_path__ + "static/media/ways-of-working.ef7d8a018cfc03a508d6f85b215d5bc3.svg";
export { ForwardRef as ReactComponent };